import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';

export class ErrorBoundaryAnalytics extends BaseInvitePeopleAnalytics {
	errorBoundaryRendered(attributes: { error: { message: string; stack: string | undefined } }): void {
		const { productTitle, source, subProduct } = this.commonAttributes;

		this.fireOperational({
			action: AnalyticsAction.RENDERED,
			actionSubject: AnalyticsActionSubject.ERROR_BOUNDARY,
			attributes: {
				product: productTitle,
				source,
				subProduct,
				...attributes,
			},
		});
	}

	inviteFormFailedToLoad(error: { message: string; stack: string | undefined }): void {
		const { source } = this.commonAttributes;

		this.fireOperational({
			action: AnalyticsAction.FAILED,
			actionSubject: AnalyticsActionSubject.INVITE_FORM,
			attributes: { error, integration: source },
		});
	}
}
